import { defineStore } from 'pinia';
import { getpoffice, getpoffices, createpoffice, hasUsedOffice } from '@/services/modules/poffice';
import { REGEX } from '@/constants/modules/common';

export interface pOffice {
  id: string;
  name: string;
  pos_code: string;
  tel: string;
  address: string;
  email: string;
}
const defaultPoffice = {
  id: '',
  name: '',
  pos_code: '',
  tel: '',
  address: '',
  email: ''
};

export const usePOfficeStore = defineStore('poffice', {
  state() {
    return {
      poffice: {} as pOffice | null,
      poffices: [] as pOffice[],
      prefixApi: ''
    };
  },
  persist: {
    paths: ['poffice', 'poffices']
  },
  getters: {},
  actions: {
    fetchPrefix(prefix: string) {
      this.prefixApi = prefix;
    },
    async fetchPoffice(id?: number) {
      if (!id) {
        this.poffice = defaultPoffice;
      } else {
        const response: any = await getpoffice(id);
        this.poffice = response;
      }
    },
    async fetchPoffices() {
      const response: any = await getpoffices();
      if (REGEX.RESPONSE_20X.test(response.status)) {
        this.poffices = response.data;
      }
    },
    async createpoffice(
      name: string,
      pos_code: string,
      tel: string,
      address: string,
      email: string
    ) {
      const response = await createpoffice({
        name,
        pos_code,
        tel,
        address,
        email
      });
      return response;
    },
    async hasUsedOffice(pOfficeId: number) {
      const response: any = await hasUsedOffice(pOfficeId);
      return response.result;
    }
  }
});
